<template>
  <div @click="$emit('click')" style="margin: -1rem; padding: 1rem;">
    <img :src="src" alt="menu" />
  </div>
</template>

<script>
import lightSrc from '@/assets/common/menu-w.svg';
import darkSrc from '@/assets/common/menu.svg';

export default {
  name: 'ShowMenu',
  props: {
    light: Boolean,
  },
  computed: {
    src() {
      return this.light ? lightSrc : darkSrc;
    },
  },
};
</script>
